import { IApplicationState } from '../types/redux';

export function selectIsWebview(state: IApplicationState) {
  return state.page.isWebview;
}
